import { render, staticRenderFns } from "./SaleHistory.vue?vue&type=template&id=6af806f9&scoped=true"
import script from "./SaleHistory.vue?vue&type=script&lang=ts"
export * from "./SaleHistory.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistory.vue?vue&type=style&index=0&id=6af806f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af806f9",
  null
  
)

export default component.exports